import { ANNOTATION_TYPE } from '../../../labelling/constants';
import type { AnnotationDataT, CuboidDataT, EllipseDataT, PointDataT, PolygonDataT, PolylineDataT, RectDataT, SkeletonDataT } from '../../../labelling/types';
export enum Direction {
  LEFT = 'left',
  RIGHT = 'right',
  UP = 'up',
  DOWN = 'down',
}
const MOVE_STEP = 1;
export type MoveConfig = Record<Direction, (data: AnnotationDataT) => AnnotationDataT>;
const pointMoveConfig = {
  [Direction.LEFT]: (data: RectDataT | PointDataT) => ({
    ...data,
    x: data.x - MOVE_STEP
  }),
  [Direction.RIGHT]: (data: RectDataT | PointDataT) => ({
    ...data,
    x: data.x + MOVE_STEP
  }),
  [Direction.UP]: (data: RectDataT | PointDataT) => ({
    ...data,
    y: data.y - MOVE_STEP
  }),
  [Direction.DOWN]: (data: RectDataT | PointDataT) => ({
    ...data,
    y: data.y + MOVE_STEP
  })
};
const ellipseMoveConfig = {
  [Direction.LEFT]: (data: EllipseDataT) => ({
    ...data,
    centerX: data.centerX - MOVE_STEP
  }),
  [Direction.RIGHT]: (data: EllipseDataT) => ({
    ...data,
    centerX: data.centerX + MOVE_STEP
  }),
  [Direction.UP]: (data: EllipseDataT) => ({
    ...data,
    centerY: data.centerY - MOVE_STEP
  }),
  [Direction.DOWN]: (data: EllipseDataT) => ({
    ...data,
    centerY: data.centerY + MOVE_STEP
  })
};
const polylineMoveConfig = {
  [Direction.LEFT]: (data: PolygonDataT | PolylineDataT | CuboidDataT) => ({
    ...data,
    points: data.points.map(([x, y]: [number, number]) => ([x - MOVE_STEP, y] as [number, number]))
  }),
  [Direction.RIGHT]: (data: PolygonDataT | PolylineDataT | CuboidDataT) => ({
    ...data,
    points: data.points.map(([x, y]: [number, number]) => ([x + MOVE_STEP, y] as [number, number]))
  }),
  [Direction.UP]: (data: PolygonDataT | PolylineDataT | CuboidDataT) => ({
    ...data,
    points: data.points.map(([x, y]: [number, number]) => ([x, y - MOVE_STEP] as [number, number]))
  }),
  [Direction.DOWN]: (data: PolygonDataT | PolylineDataT | CuboidDataT) => ({
    ...data,
    points: data.points.map(([x, y]: [number, number]) => ([x, y + MOVE_STEP] as [number, number]))
  })
};
const skeletonMoveConfig = {
  [Direction.LEFT]: (data: SkeletonDataT) => ({
    ...data,
    nodes: data.nodes.map((node: any) => ({
      ...node,
      point: [node.point[0] - MOVE_STEP, node.point[1]]
    }))
  }),
  [Direction.RIGHT]: (data: SkeletonDataT) => ({
    ...data,
    nodes: data.nodes.map((node: any) => ({
      ...node,
      point: [node.point[0] + MOVE_STEP, node.point[1]]
    }))
  }),
  [Direction.UP]: (data: SkeletonDataT) => ({
    ...data,
    nodes: data.nodes.map((node: any) => ({
      ...node,
      point: [node.point[0], node.point[1] - MOVE_STEP]
    }))
  }),
  [Direction.DOWN]: (data: SkeletonDataT) => ({
    ...data,
    nodes: data.nodes.map((node: any) => ({
      ...node,
      point: [node.point[0], node.point[1] + MOVE_STEP]
    }))
  })
};
export const ANNOTATION_MOVE_CONFIG: Record<keyof typeof ANNOTATION_TYPE, MoveConfig | null> = {
  [ANNOTATION_TYPE.RECTANGLE]: pointMoveConfig,
  [ANNOTATION_TYPE.ELLIPSE]: ellipseMoveConfig,
  [ANNOTATION_TYPE.KEY_POINT]: pointMoveConfig,
  [ANNOTATION_TYPE.POLYGON]: polylineMoveConfig,
  [ANNOTATION_TYPE.POLYLINE]: polylineMoveConfig,
  [ANNOTATION_TYPE.CUBOID]: polylineMoveConfig,
  [ANNOTATION_TYPE.SKELETON]: skeletonMoveConfig,
  [ANNOTATION_TYPE.FRAME_CLASSIFICATION]: null,
  [ANNOTATION_TYPE.SEGMENTATION]: null
};